export { default } from './StockColorPickerSelect';
